import { render, staticRenderFns } from "./GenericFormComponent.vue?vue&type=template&id=42840f23&"
import script from "./GenericFormComponent.vue?vue&type=script&lang=js&"
export * from "./GenericFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports